import { useCheckAccountType } from '@cmg/auth';
import { useDebouncedCallback } from 'use-debounce';

import { useFeatureToggles } from '../../../../../../../../../../../common/config';
import { suppressLoadingOnRefetch } from '../../../../../../../../../../../common/util/suppressLoadingOnRefetch';
import { useRefetchBackoff } from '../../../../../../../../../../../common/util/use-refetch-backoff';
import { useOrderBook_IndicationChangedSubscription } from '../../../../../../../../../../../features/order-book/graphql/__generated__';
import {
  IndicationForm_IndicationAcknowledgementsQueryVariables,
  useIndicationForm_IndicationAcknowledgementsQuery,
} from '../graphql/__generated__';

export const useInstitutionalIndicationAcknowledgementsQuery = (
  variables: IndicationForm_IndicationAcknowledgementsQueryVariables,
  skip: boolean = false
) => {
  const { isOrderBookIndicationActivitySubscriptionOn } = useFeatureToggles();

  const isSellSideAccount = useCheckAccountType('SELL_SIDE');

  const queryResult = useIndicationForm_IndicationAcknowledgementsQuery({
    variables,
    pollInterval: isOrderBookIndicationActivitySubscriptionOn ? undefined : 5000,
    fetchPolicy: isOrderBookIndicationActivitySubscriptionOn ? 'cache-and-network' : 'network-only',
    skip: !isSellSideAccount || skip,
  });

  const { loading, networkStatus, refetch } = queryResult;

  const refetchBackoff = useRefetchBackoff();
  const refetchDebounced = useDebouncedCallback(() => refetch(), refetchBackoff, {
    maxWait: refetchBackoff,
  });

  useOrderBook_IndicationChangedSubscription({
    variables,
    skip: !isOrderBookIndicationActivitySubscriptionOn,
    ignoreResults: true,
    onData: refetchDebounced,
  });

  return { ...queryResult, loading: suppressLoadingOnRefetch(loading, networkStatus) };
};
